import { render, staticRenderFns } from "./GiftGallery.vue?vue&type=template&id=30c1904c&"
import script from "./GiftGallery.vue?vue&type=script&lang=js&"
export * from "./GiftGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports